module.exports = __webpack_public_path__ + "static/media/connection-badge.e4a49ef6.svg";